export default __webpack_public_path__ + "static/media/12.0bb1b405.png";